

function movePill(header, activeTab) {
    const wrapper = header.closest('.dcContentTabs__headerWrap');
    const pill = wrapper?.querySelector('.dcContentTabs__pill');
    if (!pill) return;
    pill.style.left = activeTab.offsetLeft + header.offsetLeft + 'px';
    pill.style.top = activeTab.offsetTop + header.offsetTop + 'px';
    pill.style.width = activeTab.offsetWidth + 'px';
    pill.style.height = activeTab.offsetHeight + 'px';
}

function setActiveContentTab(contentTabs, activeId = 0){
    const contentTabsHeader = contentTabs.querySelector('.dcContentTabs__header');
    const contentTabsContent = contentTabs.querySelector('.dcContentTabs__content');

    if(contentTabsHeader && contentTabsContent){
        const contents = contentTabsContent.children;
        const contentHeaderChildren = contentTabsHeader.querySelectorAll(':scope > button');

        if(contents){
            let count = 0;
            for(const contentHeaderTab of contentHeaderChildren){
                contentHeaderTab.classList.remove("is-active");
                contentHeaderTab.setAttribute("aria-selected","false");
                if(count === activeId){
                    contentHeaderTab.classList.add("is-active");
                    contentHeaderTab.setAttribute("aria-selected","true");
                    movePill(contentTabsHeader, contentHeaderTab);
                }
                count++;
            }
            count = 0;
            for(const content of contents){
                content.classList.remove("is-active");
                if(count === activeId){
                    content.classList.add("is-active");
                }
                count++;
            }
        }
    }
}

function buildContentTabs(contentTabs){
    const contentTabsHeader = contentTabs.querySelector('.dcContentTabs__header');
    const contentTabsContent = contentTabs.querySelector('.dcContentTabs__content');

    if(contentTabsHeader && contentTabsContent){
        const contents = contentTabsContent.children;

        if(contents){
            for(const content of contents){
                content.classList.add("dcContentTabs__contentItem");
            }
        }
    }

    if (contentTabsHeader && !contentTabsHeader.parentNode.classList.contains('dcContentTabs__headerWrap')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'dcContentTabs__headerWrap';
        contentTabsHeader.parentNode.insertBefore(wrapper, contentTabsHeader);
        wrapper.appendChild(contentTabsHeader);
        const pill = document.createElement('div');
        pill.className = 'dcContentTabs__pill';
        wrapper.appendChild(pill);
    }

    contentTabs.classList.add("initialized");
}

function getCurrentIndex(tabs,currentTab){
    let index = 0;

    for(const tab of tabs){
        if(tab === currentTab){
            return index;
        }
        index++;
    }
}

function setEventListenerForTab(contentTabs){
    const contentTabsHeader = contentTabs.querySelector('.dcContentTabs__header');
    if(contentTabsHeader){
        const contentHeaderChildren = contentTabsHeader.querySelectorAll(':scope > button');

        if(contentHeaderChildren){
            for(const tab of contentHeaderChildren){
                tab.addEventListener("click",function (){
                    setActiveContentTab(contentTabs,getCurrentIndex(contentHeaderChildren,tab));
                });
            }
        }
    }
}

export function initContentTabs(wrapper = document){
    for(const contentTabs of wrapper.querySelectorAll('.dcContentTabs:not(.initialized)')){
        buildContentTabs(contentTabs);
        setActiveContentTab(contentTabs);
        setEventListenerForTab(contentTabs);
        const header = contentTabs.querySelector('.dcContentTabs__header');
        const activeTab = header?.querySelector(':scope > button.is-active');
        if (header && activeTab) {
            if (activeTab.offsetWidth > 0) {
                movePill(header, activeTab);
            } else {
                const observer = new ResizeObserver(() => {
                    if (activeTab.offsetWidth > 0) {
                        movePill(header, activeTab);
                        observer.disconnect();
                    }
                });
                observer.observe(activeTab);
            }
        }
    }
}